const buildVXCPortfolioAlertsCsvData = (portfolioName, response) => {
    const getUniqueAlertToSource = (alertTypes) => {
      const alertSources = new Set();

      alertTypes.forEach((alertType) => {
        const alertTypeRecords = response.filter((record) => record.brand === alertType);
        console.log(alertTypeRecords);
        alertTypeRecords.forEach((record) => {
          alertSources.add(`${alertType}-${record.financeCompanyName}`);
        });
      });

      return alertSources;
    };

    const buildRows = () => {
      const totalUniqueVins = new Set(response.map(record => record.vin));
      const totalRow = [portfolioName, 'All Alert Types', 'All Sources', response.length.toString(), totalUniqueVins.size.toString()];
      const alertTypes = new Set(response.map(record => record.brand));
      const alertSources = getUniqueAlertToSource(alertTypes);
      const alertSourceCounts = {};

      response.forEach((record) => {
        alertSources.forEach((source) => {
          if (`${record.brand}-${record.financeCompanyName}` == source) {
            if (source in alertSourceCounts) {
              alertSourceCounts[source] += 1;
            } else {
              alertSourceCounts[source] = 1;
            }
          }
        });
      });

      const rowData = [];

      Object.entries(alertSourceCounts)
        .forEach((alertSource) => {
          const key = alertSource[0];
          console.log(key);
          const parts = key.split('-');
          console.log(parts);
          rowData.push([portfolioName, parts[0], parts[1], alertSource[1], '']);
        });

      rowData.unshift(totalRow);
      return rowData;
    };


    const dataHeader = [
      'Portfolio',
      'Alert Type',
      'Source',
      'Alerts',
      'VINS'
    ];

    const rows = buildRows();
    rows.unshift(dataHeader);
    return rows;
  }
;

export default buildVXCPortfolioAlertsCsvData;


// WEBPACK FOOTER //
// ./src/helpers/vxc/reports/csv/buildAlertReportData.js